import Swiper, {
  Navigation, Pagination, EffectFade, Lazy, Autoplay,
} from 'swiper/core';
import Validation from '@/js/components/forms/validation';
import SwiperInstagram from '../components/swiper/instagram';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, EffectFade, Lazy, Autoplay]);

class Home {
  constructor() {
    this.dom = {
      subscriberForm: document.getElementById('subscriber-form'),
      swiperIntro: document.getElementById('swiper-intro'),
      swiperInstagram: document.querySelectorAll('.swiper-instagram'),
    };

    this.data = {
      swiperConfig: {
        loop: true,
        speed: 1500,
        autoplay: {
          delay: 3500,
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: {
          checkInView: true,
          loadPrevNext: true,
        },
        effect: 'fade',
      },
    };

    this.components = {
      subscriberFormValidation: null,
      swiperInstance: null,
      swiperInstagramInstances: [],
    };

    this.mount();
  }

  mount() {
    if (this.dom.subscriberForm) {
      this.components.subscriberFormValidation = new Validation(this.dom.subscriberForm);
      // this.dom.formContact.addEventListener('submit', this.submitForm.bind(this));
    }

    if (this.dom.swiperIntro) {
      this.components.swiperInstance = new Swiper(this.dom.swiperIntro, this.data.swiperConfig);
    }

    this.dom.swiperInstagram.forEach((swiperEl) => {
      this.components.swiperInstagramInstances.push(new SwiperInstagram(swiperEl));
    });
  }
}

if (document.getElementById('page-home')) {
  // eslint-disable-next-line no-new
  new Home();
}
